import { ReactNode } from "react";
import { useViewport } from "../../context/viewport/ViewportContext";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT,
} from "../../constants";

interface ViewportOnlyProps {
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  children: ReactNode;
}

export default function ViewportOnly({
  small,
  medium,
  large,
  children,
}: ViewportOnlyProps) {
  const { viewportCategory } = useViewport() as { viewportCategory: string };

  const isVisible =
    (small && viewportCategory === SMALL_VIEWPORT) ||
    (medium && viewportCategory === MEDIUM_VIEWPORT) ||
    (large && viewportCategory === LARGE_VIEWPORT);

  return isVisible ? <>{children}</> : null;
}
